import { render, staticRenderFns } from "./FormControlTextItalic.vue?vue&type=template&id=359e55e3"
import script from "./FormControlTextItalic.vue?vue&type=script&lang=js"
export * from "./FormControlTextItalic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports